import React, { useState, useEffect,useCallback , useContext ,useRef } from "react";
import {
Typography,
Row,
Col,
Form,
Space,
Button,
Select,

}from 'antd';
import { Content } from "antd/es/layout/layout";
import {getListFutureIndustry, getListIndustry,getListYearFuture} from "../../../../services/vocReportService";
import {SearchFutureVocContext,initialSearchValues,initialPageValues} from "../searchContext";
const { Title } = Typography;
const { Option } = Select;

const ListIndustry = () => {

    const [data, setData] = useState([]);
  
    const fetchData = useCallback(async () => {
      const res = await getListIndustry();
      if (res.data.code === "0000") {
        const { objectValue } = res.data;
        setData(objectValue);
      }
    }, [setData]);
  
    useEffect(() => {
      fetchData();
    }, [fetchData]);
  
    return [data];
  };
  const ListFutureIndustry = () => {

    const [data, setData] = useState([]);
  
    const fetchData = useCallback(async () => {
      const res = await getListFutureIndustry();
      if (res.data.code === "0000") {
        const { objectValue } = res.data;
        setData(objectValue);
      }
    }, [setData]);
  
    useEffect(() => {
      fetchData();
    }, [fetchData]);
  
    return [data];
  };
const ListYearFuture = () => {

    const [data, setData] = useState([]);

    const fetchData = useCallback(async () => {
        const res = await getListYearFuture();
        if (res.data.code === "0000") {
        const { objectValue } = res.data;
        setData(objectValue);
        }
    }, [setData]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return [data];
};
const quarter = [
    {value: 1},
    {value: 2},
    {value: 3},
    {value: 4},
]
const Search = ({onTypeChange}) => {
    ;
      const {
        setPageValues,
        setSearch,

        setSearchValues,
      } = useContext(SearchFutureVocContext);
    const [searchForm] = Form.useForm();
    const [industryType] = ListIndustry();
    const [futureIndustryType] = ListFutureIndustry();
    const [yearOfBudget] = ListYearFuture();
    // const industryFilter = industryType.filter(item => item.nameTh !== 'ไม่สามารถระบุข้อมูลได้');
    const typeValue = Form.useWatch("Type", searchForm); // ค่าจะเป็น 0/1 ตามที่คุณ set ใน Option

  // filter ของแต่ละชุด
  const industryFilter = (industryType ?? []).filter(
    (item) => item.nameTh !== "ไม่สามารถระบุข้อมูลได้"
  );

  const futureIndustryFilter = (futureIndustryType ?? []).filter(
    (item) => item.nameTh !== "ไม่สามารถระบุข้อมูลได้"
  );

  const industryOptions = typeValue === 1 ? industryFilter : futureIndustryFilter;
    const first = useRef(true);

    useEffect(() => {
    // ถ้าไม่อยากให้ reset ตอน mount ครั้งแรก ให้ข้าม
    if (first.current) {
        first.current = false;
        return;
    }

    // เปลี่ยน Type แล้วล้าง industryType
    searchForm.setFieldsValue({ industryType: undefined });
    // หรือ: searchForm.resetFields(["industryType"]);
    }, [typeValue, searchForm]);


    const onSearch = (value) => {
        // const current_future_Customer = [
        //     "4d3d303d-ca38-11f0-8f16-005056014b8c"
        //     ,"4d3d4568-ca38-11f0-8f16-005056014b8c"
        //     ,"4d3e2cfb-ca38-11f0-8f16-005056014b8c"
        //     ,"4d3e2e23-ca38-11f0-8f16-005056014b8c"
        //     ,"4d3e2e97-ca38-11f0-8f16-005056014b8c"
        // ];
        // const old_future_Customer = [
        //     "02915df5-f9d1-4193-a251-396897c5b4d1"
        //     ,"38822bf4-3411-11ee-b359-005056014b8c"
        //     ,"ff3b7ae8-d200-4ff2-96bb-85720f1ae4e4"
        // ];
        setSearch(true);
        // const type = String(value?.Type); 
        // const isIndustryEmpty = !Array.isArray(value?.industryType) || value.industryType.length === 0;
        let industryTypes = [];
        let yearOfBudgets = [];
        let quarters = [];
        let strType = 'future_industry_type';
        
        if(value?.Type === 1 ){
            strType = 'industry_type'
        }
        console.log('search :',value)
        let Types = strType;
        quarters = value?.quarter;
        yearOfBudgets = value?.yearOfBudget;
        industryTypes = value?.industryType;
        // if(type ==="0" && isIndustryEmpty){
        //     industryTypes = current_future_Customer;
        // }else  if(type ==="1" && isIndustryEmpty){
        //     industryTypes = old_future_Customer;
        // }else {
        //     industryTypes = value?.industryType;
        // }
        console.log( 'industryTypes :',industryTypes);
        setSearchValues({
            TypeFuture:Types,
            industryType: industryTypes,
            yearOfBudget: yearOfBudgets,
            quarter:quarters
        })}
    const handleClearSearchForm = () => {
        searchForm.resetFields();
        setSearchValues(initialSearchValues);
        setPageValues(initialPageValues);
        setSearch(true);
      };

    return (

    <Content>
        <Form>
            <Row gutter={[24, 24]}>
            <Col span={24}>
                <div className="flex justify-between items-center">
                <Title level={4} style={{ marginTop: 15, color: "#6442A4" }}>
                    รายงาน
                </Title>
                </div>
            </Col>
            </Row>
        </Form>
        <Form 
            layout={"vertical"}
            form={searchForm}
            style={{
                padding: 20,
                backgroundColor: "#fff",
                borderRadius: "12px",
                border: "1px solid #F2F2F2",
                boxShadow: `0px 1px 10px 0px rgba(226, 216, 246, 0.40)`,
            }}
            initialValues={{
                Type: 0,           
            }}
        onFinish={(value) =>
            onSearch({
              ...value,
            })
        }
        >
            <Row gutter={[24, 16]}>
                <Col className="gutter-row" span={6}>
                    <Form.Item name="Type">
                        <Select
                            allowClear
                            style={{
                            width: "100%",
                            }}
                            placeholder="กลุ่มลูกค้า..."
                            maxTagCount={"responsive"}
                            onChange={(value) => {
                                onTypeChange(value);
                            }}
                        >
                        <Option value={1}>ลูกค้าอนาคต (2568)</Option>
                        <Option value={0}>ลูกค้าอนาคต (2569)</Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={6}>
                    <Form.Item name="yearOfBudget">
                        <Select
                            allowClear
                            style={{
                            width: "100%",
                            }}
                            placeholder="ปีงบประมาณ"
                            maxTagCount={"responsive"}
                        >

                            {yearOfBudget.map((a) => (
                            <Option value={a.yearOfBudget}>
                                {Number(a.yearOfBudget)+543}
                            </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={6}>
                    <Form.Item name={"quarter"}>
                        <Select
                        allowClear
                        style={{
                            width: "100%",
                        }}
                        placeholder="ไตรมาส"
                        maxTagCount={"responsive"}
                        >
                        {quarter.map((l) => (
                        <Option value={l.value}>{l.value}</Option>
                        ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={6}>
                    <Form.Item name="industryType">
                        <Select
                            allowClear
                            style={{
                            width: "100%",
                            }}
                            placeholder="กลุ่มลูกค้า"
                            maxTagCount={"responsive"}
                        >
                            {industryOptions.map((a) => (
                            <Option value={a.age}>
                                {a.nameTh}
                            </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={24} align="right">
                    <Space>
                        <Button onClick={handleClearSearchForm}>ล้างข้อมูล</Button>
                        <Button type="primary" htmlType="submit">
                            ค้นหา
                        </Button>
                    </Space>
                </Col>
            </Row>
        </Form>
    </Content>
  );
};

export default Search;